<app-organizer-shared-layout-edit-field
  [title]="'organizer.edit.timeslot.select_timeslots.title' | translate"
  [isFormValid]="isFormValid"
  [isFormDirty]="formGroup.dirty"
  [isOverlayDisplayed]="isOverlayDisplayed"
  [overlayStatus]="overlayStatus"
  [previousUrl]="previousUrl"
  (submitted)="submitted()"
>
  <ng-container [formGroup]="formGroup">
    <app-form-checkbox
      class="block mt-4"
      formControlName="select-all"
      [label]="
        'organizer.edit.timeslot.select_timeslots.select-all'
          | translate: { count: timeslots.length }
      "
      (change)="toggleTimeslotsSelection()"
    ></app-form-checkbox>

    <app-divider></app-divider>

    <ul>
      <li
        *ngFor="let timeslot of displayedTimeslots; let isFirst = first"
        [class.mt-3]="!isFirst"
        class="flex items-center"
        [formGroup]="formGroup.controls.timeslots"
      >
        <app-form-checkbox
          class="mr-8"
          [formControlName]="timeslot.identifier"
          [ariaLabel]="timeslot.startDate.toString()"
          (change)="toggleTimeslotSelection()"
        ></app-form-checkbox>

        <app-timeslot
          [activity]="activity"
          [timeslot]="timeslot"
          [containerClass]="'p-3'"
          class="flex-1"
        ></app-timeslot>
      </li>
    </ul>

    <button
      *ngIf="numberOfTimeslotToDisplay < timeslots?.length"
      app-vtmn-play-button
      type="button"
      class="w-full mt-6"
      [variant]="vtmnPlayButtonVariant.SECONDARY"
      [type]="ctaButtonType.Button"
      (click)="loadMoreTimeslots()"
    >
      {{ 'organizer.edit.timeslot.select_timeslots.load_more' | translate }}
    </button>
  </ng-container>
</app-organizer-shared-layout-edit-field>
